import { render, staticRenderFns } from "./salary-sheet.vue?vue&type=template&id=78474d88&"
import script from "./salary-sheet.vue?vue&type=script&lang=js&"
export * from "./salary-sheet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports